document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('input.convert-halfwidth').forEach(function (input) {
    input.addEventListener('input', function () {
      this.value = this.value
        .replace(/[！-～]/g, function (char) {
          return String.fromCharCode(char.charCodeAt(0) - 0xFEE0);
        })
        .replace(/　/g, ' ');
    });
  });
});